var _defs, _g, _g2, _g3, _g4, _g5, _g6, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetUpHeating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484.7424,
    height: 1071.0363,
    viewBox: "0 0 484.7424 1071.0363",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    id: "svg1349",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Set-up-heating",
    transform: "matrix(0.829192,0,0,1.09268,-642.81771,-1681.8689)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.723793,-0.0254776,0.0373356,-0.610804,1770.22,3321.51)",
    id: "g1240"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.47732,0,0,0.98127,-198.447,817.785)",
    id: "g1216"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 788.34497,
    y: 1224.79,
    width: 144.45399,
    height: 352.77899,
    id: "rect1214"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.534724,0,0,0.510865,560.514,1527.55)",
    id: "g1220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 815.94098,
    y: 1619.91,
    width: 116.859,
    height: 129.112,
    id: "rect1218"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.534724,0,0,0.510865,654.1,1527.55)",
    id: "g1224"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 815.94098,
    y: 1619.91,
    width: 116.859,
    height: 129.112,
    id: "rect1222"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1230"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 818.41199,
    y: 1388.4,
    width: 147.243,
    height: 129.565,
    id: "rect1226"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.41199,
    y: 1388.4,
    width: 147.243,
    height: 129.565,
    id: "rect1228"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14922,0.116279,-0.0956579,0.487818,172.427,1352.26)",
    id: "g1234"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 918.01703,
    y: 499.34299,
    width: 41.382999,
    height: 702.94501,
    id: "rect1232"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1001.97,588.671 c 29.56,-131.916 -64.401,-304.576 -123.778,-177.417 -172.104,431.022 233.488,257.05 -44.073,-41.295 -61.948,-11.612 -68.231,108.349 -71.203,195.404 12.411,87.783 60.986,341.603 66.681,381.883",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "43.51px"
    },
    id: "path1236"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,22.7691,1146.5)",
    id: "g1246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 778.81,1158.26 c -1.428,-4.78 2.902,0.79 5.444,6.43 0,0 -41.149,122.5 11.856,189.68 -69.892,-77.1 -22.95,-160.83 -17.3,-196.11 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 778.81,1158.26 c -1.428,-4.78 2.902,0.79 5.444,6.43 0,0 -41.149,122.5 11.856,189.68 -69.892,-77.1 -22.95,-160.83 -17.3,-196.11 z m 1.295,2.24 c 0.788,1.23 1.632,2.75 2.362,4.29 -1.801,5.58 -14.719,47.21 -15.095,93.78 -0.194,24.06 2.97,49.42 12.673,71.87 -23.915,-38.58 -22.713,-77.46 -16.082,-109.78 5.114,-24.93 13.427,-46 16.142,-60.16 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1244"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 864.812,1321.05 c 0,0 6.391,30.24 -27.607,15.33 16.976,0.74 23.098,-1.06 27.607,-15.33 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 864.812,1321.05 c 0,0 1.598,7.56 -1.054,13.26 -2.652,5.7 -9.554,9.53 -26.553,2.07 16.976,0.74 23.098,-1.06 27.607,-15.33 z m -1.299,7.56 c -0.016,0.16 -0.034,0.32 -0.053,0.48 -0.308,2.53 -1.096,5.23 -3.027,7.16 -1.578,1.57 -3.921,2.57 -7.313,2.6 -1.779,0.01 -3.82,-0.24 -6.162,-0.81 5.285,-0.37 9.126,-1.49 12.125,-3.92 1.701,-1.37 3.15,-3.17 4.429,-5.51 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1250"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-51.0189,1125.12)",
    id: "g1256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 986.14,1181.77 c 0,0 26.1,70.53 0,149.46",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1254"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19012,0.147971,-0.194991,0.903138,195.064,993.426)",
    id: "g1260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 986.14,1181.77 942.345,1049.43",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1258"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.765918,0,0,0.915179,375.227,1150.43)",
    id: "g1264"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 852.807,726.589 29.758,0.65 c 0,0 -18.243,7.657 -16.099,13.822 2.145,6.165 1.477,18.597 4.065,18.863 2.589,0.266 -17.887,0.813 -17.887,0.813 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1262"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20559,0.00754534,0.00994299,0.729673,-1.30797,1280.07)",
    id: "g1268"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 912.405,732.181 -1.161,28.556",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "10.63px",
      strokeLinejoin: "round"
    },
    id: "path1266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 946.919,795.174 936.736,982.502",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "9.69px",
      strokeLinejoin: "round"
    },
    id: "path1270"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 903.538,676.356 c 0,0 23.794,-185.06 -3.965,-230.003",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "43.07px",
      strokeLinecap: "round"
    },
    id: "path1274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0.784476,1150.07)",
    id: "g1280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 885.012,446.75 c 0,0 28.161,5.27 8.734,195.938",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "9.69px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1278"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 951.238,651.954 -100.107,-3.303 23.121,16.007 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1282"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1288"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 851.131,651.827 v 61.615 l 36.587,-4.828 c 0,0 -26.17,-3.303 -36.587,-56.787 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1286"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 851.131,719.54 26.932,-6.098 68.856,11.433 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1290"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1298"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 843.869,771.062 110.244,-0.993 c 0,0 -110.244,19.354 -110.244,124.56 -4.085,74.934 15.718,68.979 74.297,91.31 -10.422,0.496 -86.348,-3.97 -86.348,-3.97 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 843.869,771.062 110.244,-0.993 c 0,0 -110.244,19.354 -110.244,124.56 -4.085,74.934 15.718,68.979 74.297,91.31 -10.422,0.496 -86.348,-3.97 -86.348,-3.97 z m -1.82,201.79 0.88,-15.394 0.249,0.412 c 4.237,6.739 9.833,11.78 17.071,16 l -9.36,-0.517 c -2.947,-0.167 -5.893,-0.334 -8.84,-0.501 z m 8.157,-142.756 2.824,-49.421 48.285,-0.435 c -18.424,10.621 -37.905,26.504 -51.109,49.856 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1296"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24437,-0.110268,-0.145307,1.33264,129.934,831.711)",
    id: "g1302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 824.345,993.013 802.811,1093.14",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "8.48px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1300"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-6.07916,1143.23)",
    id: "g1306"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 944.508,1008.19 c 14.088,103.91 38.435,202.58 37.624,223.64 0.476,19.03 -5.621,113.45 -44.815,132.88 -18.84,9.33 -40.372,-7.53 -43.543,-16.64",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1304"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-7.47793,1156.38)",
    id: "g1312"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 922.161,1165.45 c 1.983,-2.47 -37.234,-45.35 -73.417,10.81 -39.246,68.9 36.451,151.41 36.451,151.41 0,0 -55.348,-113.11 -18.493,-151.71 6.692,-10.05 47.026,-19.4 55.459,-10.51 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 922.161,1165.45 c 1.983,-2.47 -37.234,-45.35 -73.417,10.81 -39.246,68.9 36.451,151.41 36.451,151.41 0,0 -55.348,-113.11 -18.493,-151.71 6.692,-10.05 47.026,-19.4 55.459,-10.51 z m -4.87,-4.33 c -0.332,-0.09 -0.673,-0.17 -1.022,-0.24 -4.218,-0.87 -9.714,-0.84 -15.549,-0.12 -8.617,1.06 -17.984,3.61 -24.985,6.81 -4.847,2.21 -8.573,4.79 -10.337,7.34 -6.05,6.39 -9.711,14.71 -11.546,24.22 -2.707,14.02 -1.433,30.64 1.803,47.23 5.424,27.81 16.339,55.53 22.837,70.56 -9.024,-11.69 -23.63,-33.01 -32.296,-58.14 -8.731,-25.33 -11.44,-54.56 3.971,-81.66 12.277,-19.03 24.828,-26.43 35.984,-27.76 11.022,-1.31 20.575,3.3 26.86,8.05 1.669,1.26 3.108,2.53 4.28,3.71 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1310"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.956709,0,0,0.673311,-115.865,826.292)",
    id: "g1318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1316"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1463.1,1693.76 c 12.36,7.4 23.8,16.69 33.97,27.65 29.07,31.35 45.4,73.86 45.4,118.19 v 481.67 c 0,60.68 -34.85,112.59 -84.16,133.68 3.14,3.27 4.79,6.67 4.79,10.16 0,27.32 -101.33,49.5 -226.15,49.5 -124.82,0 -226.16,-22.18 -226.16,-49.5 0,-3.49 1.65,-6.89 4.8,-10.16 -49.317,-21.09 -84.169,-73 -84.169,-133.68 V 1839.6 c 0,-44.33 16.332,-86.84 45.402,-118.19 10.169,-10.96 21.605,-20.25 33.967,-27.65 v -94.98 h 452.31 z m -59.07,736.66 c -31.83,6.93 -103.18,20.71 -167.08,20.71 -63.91,0 -135.26,-13.78 -167.09,-20.71 -6.04,-15.59 -17.7,-28.11 -32.57,-34.47 -27.54,-11.78 -47.001,-40.78 -47.001,-74.68 0,-135.64 0,-338.89 0,-481.67 0,-27.49 10.131,-53.86 28.161,-73.3 6.26,-6.76 13.3,-12.48 20.91,-17.04 18.7,-11.19 30.3,-32.44 30.3,-55.5 v -31.5 c 0,0 224.83,0 334.58,0 0,0 0,31.5 0,31.5 0,23.06 11.59,44.31 30.29,55.5 7.61,4.56 14.65,10.28 20.91,17.04 18.03,19.44 28.16,45.81 28.16,73.3 v 481.67 c 0,33.9 -19.45,62.9 -47,74.68 -14.87,6.36 -26.53,18.88 -32.57,34.47 z",
    id: "path1314"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35052,0,0,0.915179,-243.95,1150.29)",
    id: "g1324"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.09399,
    cy: 1434.61,
    rx: 111.507,
    ry: 11.436,
    style: {
      fill: "#ffffff"
    },
    id: "ellipse1320"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.09399,
    cy: 1434.61,
    rx: 111.507,
    ry: 11.436,
    id: "ellipse1322"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1059.42,826.919 -12.61,11.882 -304.878,14.373 1.067,29.962 c 0,0 1.914,1.901 -2.26,10.804 -21.133,11.573 -70.759,58.86 -70.759,127.79 0,68.94 -16.626,107.4 -22.655,109.92 -0.017,-48.15 -0.048,-130.7 -0.048,-130.7 0,0 -9.572,-54.002 69.03,-107.841 1.832,-57.445 -5.355,-62.679 -5.355,-62.679 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1059.42,826.919 -12.61,11.882 -304.878,14.373 1.067,29.962 c 0,0 1.914,1.901 -2.26,10.804 -21.133,11.573 -70.759,58.86 -70.759,127.79 0,68.94 -16.626,107.4 -22.655,109.92 -0.017,-48.15 -0.048,-130.7 -0.048,-130.7 0,0 -9.572,-54.002 69.03,-107.841 1.832,-57.445 -5.355,-62.679 -5.355,-62.679 z m -4.25,1.71 -9.05,8.536 c 0,0 -304.266,14.344 -304.266,14.344 -0.912,0.043 -1.62,0.812 -1.587,1.724 l 1.066,29.962 1.666,1.607 -1.347,-0.698 c 0,0 0.193,0.84 0.035,1.953 -0.208,1.47 -0.825,3.609 -2.232,6.689 -21.642,12.154 -71.142,59.773 -71.142,128.984 0,47.94 -8.062,81.05 -14.972,97.45 -1.552,3.69 -3.035,6.51 -4.351,8.43 l -0.046,-126.66 c 0,-0.1 -0.009,-0.19 -0.026,-0.29 0,0 -9.179,-53.086 68.331,-106.176 0.438,-0.3 0.707,-0.791 0.724,-1.322 1.109,-34.762 -1.089,-50.565 -2.999,-57.647 -0.389,-1.442 -0.781,-2.569 -1.149,-3.447 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1328"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1334"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1059.42,835.349 v 60.593 c 0,0 57.95,39.844 60.97,102.017 3.03,62.171 0.34,365.221 0.34,365.221 0,0 5.71,43.03 -65.42,81.67 -0.39,5.06 -0.56,7.3 -0.56,7.3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1332"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1088.29,994.081 V 1362.43",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1336"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 654.195,1362.43 c 0,0 -4.66,51.28 54.196,80.45 12.397,-6.07 13.99,3.05 13.99,3.05 l -1.827,9.84 c 0,0 176.336,65.67 334.196,-3.62",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1340"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 681.734,1097.4 2.227,265.03 c 0,0 0,37.27 31.738,49.01",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path1344"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUpHeating);
export default __webpack_public_path__ + "static/media/set-up-heating.e25e3ffe93bb4fa2df84902020df93c2.svg";
export { ForwardRef as ReactComponent };